<template lang="pug">
  b-modal(
    v-model="show",
    header-class="lmm-common-popup-header",
    no-close-on-backdrop)
    template(slot="modal-header")
      img.logo(src="../../assets/main_logo.svg" style="height: 20px")
    div
      div.context.mb-2 {{$t('need_license', {v: $t('Corporate')})}}
    template(slot="modal-footer", class="w-100")
      b-btn(
        size="sm",
        variant="primary",
        @click="cancel") {{$t('submit')}}
</template>

<script>
export default {
  name: 'block-dialog',
  methods: {
    cancel () {
      this.show = false
    }
  },
  created () {
    this.AppState.$on('show-block-dialog', () => {
      this.show = true
    })
  },
  data () {
    return {
      show: false
    }
  }
}
</script>

<style lang="scss" scoped src="./dialogs.scss"></style>
